import axios from 'axios';
import { API_BASE_URL } from './config';
import { useDispatch } from 'react-redux';
import { useRedirect } from '../hooks';
import userActions from '../nair_redux/actions/userActions';

export const tokenAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: '',
    // 'Authorization': localStorage.getItem('token') || ''
  },
});

tokenAxios.interceptors.response.use(response => {
  if (response.headers.authorization) {
    setToken(response.headers.authorization);
  }
  return response;
}, error => {
  if (!axios.isCancel(error) && error.response) {
    const dispatch = useDispatch();
    const redirect = useRedirect();
    if (error.response.status === 404 && error.response.config.method === 'get') {
      redirect({ pathname: '/notfound' });
    } else if (error.response.status === 401) {
      // --- Re-login modal here ---//
      dispatch(userActions.logOut());
      redirect({ pathname: '/login' });
    }
  }
  return Promise.reject(error);
});

export function setToken (token) {
  tokenAxios.defaults.headers.Authorization = token;
  localStorage.setItem('token', token);
}
